<template>
  <el-dialog :title="$t('send_pagements.create_large_value_payment')" class="diglog-card" :visible.sync="dialogTableVisible" width="540px" :close-on-click-modal="false">
    <div class="header-line" />
    <div class="section-title" />
    <div style="margin: 0 12px;">
      <el-form>
        <h2 class="font_size_title">{{ $t('merchantAccount.account_details') }}</h2>
        <div :class="{ 'account-details-row': $store.getters.isAllCountry }">
          <el-form-item v-if="$store.getters.isAllCountry" class="currency-form-item">
            <div class="currency-form-content">
              <span class="currency-label">{{ $t('data.currency') }}:</span>
              <el-select v-model="currency" class="currency-select" clearable @change="onCurrencyChange">
                <el-option
                  v-for="(item, index) in currencyOptions"
                  :key="index"
                  :label="item.currency"
                  :value="item.currency"
                />
              </el-select>
            </div>
          </el-form-item>
          <el-form-item :label="$t('merchantAccount.available_balance') + ':'">
            <span style="color: #3855F1">
              {{ total_balance | toDivideWithDot }}
            </span>
          </el-form-item>
        </div>
      </el-form>
      <div>
        <el-form ref="form" class="mt-12" :model="form" :rules="rules" label-position="left">
          <div>
            <h2 class="payout-second-title">{{ $t('merchantAccount.beneficiary_details') }}</h2>
            <el-form-item
              class="mt-12"
              :label="$t('merchantAccount.beneficiary')+ ':'"
              prop="beneficiary_id"
              :rules="[
                { required: true, message: 'Beneficiary cannot be empty', trigger: ['blur','change']}
              ]"
            >
              <br>
              <el-select v-model="form.beneficiary_id" class="from-input" :disabled="id_disabled" :placeholder="$t('merchantAccount.beneficiary')" clearable @change="onChangeBeneficiaryList">
                <el-option
                  v-for="(item,index) in beneficiaryList"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
            <el-form-item
              v-if="currentCountryCode === 'TH'"
              :label="$t('merchantAccount.beneficiary_account_type') + ':'"
            >
              {{ beneficiaryAccountTypeFormat(merchantInfo.beneficiary_account_type) }}
            </el-form-item>
            <el-form-item
              v-if="currentCountryCode === 'TH' && merchantInfo.beneficiary_account_type === 'PROMPTPAY'"
              :label="$t('merchantAccount.beneficiary_type') + ':'"
            >
              {{ beneficiaryTypeFormat(merchantInfo.beneficiary_type) }}
            </el-form-item>
            <el-form-item
              v-if="currentCountryCode !== 'TH' || merchantInfo.beneficiary_account_type === 'BANK'"
              :label="$t('merchantAccount.receiving_channel') + ':'"
            >
              {{ merchantInfo.disbursement_channel }}
            </el-form-item>
            <el-form-item
              :label="$t('merchantAccount.beneficiary_name') + ':'"
            >
              {{ merchantInfo.disbursement_name }}

            </el-form-item>
            <el-form-item
              :label="$t('merchantAccount.beneficiary_account_no') + ':'"
            >
              {{ merchantInfo.disbursement_number }}
            </el-form-item>
            <!--受益人地址-->
            <el-form-item
              v-if="currentCountryCode === 'AE'"
              :label="$t('map.benefit_address') + ':'"
            >
              {{ merchantInfo.beneficiary_address }}
            </el-form-item>
            <el-form-item
              :label="$t('merchantAccount.amount_limit') + ':'"
            >
              <div v-if="merchantInfo.disbursement_payout_limit_amount === 1">
                {{ merchantInfo.contract_amount | toDivideWithDot }}
              </div>
              <div v-else>
                /
              </div>
            </el-form-item>
          </div>

          <div>
            <h2 class="payout-second-title">{{ $t('merchantAccount.payment_details') }}</h2>
            <!-- 商户订单号 -->
            <el-form-item
              :label="$t('merchantAccount.merchant_order_id')"
              prop="merchant_order_id"
            >
              <el-input v-model.trim="form.merchant_order_id" maxlength="32" show-word-limit placeholder="Enter merchant order ID" type="text" class="from-input" autocomplete="off" clearable />
            </el-form-item>
            <el-form-item
              :label="$t('components.amount')"
              prop="amount"
              :rules="[
                { required: true, message: 'Amount cannot be empty', trigger: ['blur','change']},
                { validator: checkAmount, trigger: ['blur','change'] }
              ]"
            >
              <el-input v-model="form.amount" type="text" placeholder="Enter amount" class="from-input" autocomplete="off" clearable />
            </el-form-item>
            <el-form-item
              required
              :label="$t('merchantAccount.payment_remark') + ':'"
              style="width: 450px"
              prop="remark"
            >
              <br>
              <el-input v-model="form.remark" placeholder="Enter your message here" style="width: 450px" class="from-input" type="textarea" maxlength="256" clearable overflow: auto show-word-limit />
            </el-form-item>
            <el-form-item
              v-if="$store.getters.isOpenMfa"
              :label="$t('system.mfa_verify_code') + ':'"
              style="width: 450px"
              prop="mfa_code"
              required
            >
              <br>
              <el-input v-model="form.mfa_code" placeholder="Enter your MFA verification code" class="search-frame" maxlength="6" autocomplete="off" clearable show-word-limit />
            </el-form-item>
          </div>
        </el-form>

        <div class="cp-btn">
          <el-button class="cancel-btn" @click="onClickCancelBtn">{{ $t('components.cancel') }}</el-button>
          <el-button class="confirm-btn" type="info" :disabled="submiting" @click="onClickSubmitBtn">{{ $t('components.confirm') }}</el-button>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import {
  createLargeDisbursement,
  fetchLargeValueBeneficiaryAllList,
  fetchMultiMchLargeValueBeneficiaryAllList
} from '@/api/online-transaction/online-transaction.js'
import { fetchMultiMchOverview, fetchOverview } from '@/api/dashboard/dashboard'
import { LARGE_VALUE_PAYMENT_COUNTRY_CODES } from '@/const/const'
export default {
  name: 'SingleLargePayoutCreateModal',
  components: {
  },
  data() {
    const validateVerifyCode = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('Please input MFA Verification Code'))
      }
      if (value.includes(' ')) {
        return callback(new Error('Please do not enter spaces'))
      }
      if (value.length !== 6 || !/^\d+$/.test(value)) {
        return callback(new Error('Please enter 6 digit valid MFA Verification code'))
      }
      return callback()
    }
    this.checkAmount = (rule, value, callback) => {
      value = Number(value)
      if (this.currentCountryCode === 'VN') {
        if (value < 200000001) {
          return callback(new Error(this.$t('send_pagements.large_payment_min_amount')))
        }
        if (value > 300000000) {
          return callback(new Error(this.$t('send_pagements.large_payment_max_amount')))
        }
      } else if (this.currentCountryCode !== 'ID' && value > 10000000) {
        return callback(new Error('Currently up to 10 million'))
      }
      this.$commonFn.validateFormAmount({ rule, value, countryCode: this.currentCountryCode, callback })
      if (value > this.$commonFn.mathDivide(this.total_balance, 100)) {
        return callback(new Error('Insufficient balance!'))
      }
      if (this.currentCountryCode !== 'VN' && this.form.amount > this.maxAmount) {
        return callback(new Error('The payment amount cannot exceed the amount limit.'))
      }
      callback()
    }
    return {
      dialogTableVisible: false,
      currency: '',
      total_balance: null,
      id: null,
      listLoading: false,
      merchantInfo: {},
      form: {
        amount: undefined,
        beneficiary_id: null,
        mfa_code: ''
      },
      beneficiaryList: [],
      submiting: false,
      id_disabled: false,
      rules: {
        mfa_code: [
          { validator: validateVerifyCode, trigger: ['blur', 'change'] }
        ]
      }
    }
  },
  computed: {
    currencyOptions() {
      return this.$store.state.page.countryArr.filter(item => LARGE_VALUE_PAYMENT_COUNTRY_CODES.includes(item.code))
    },
    currentCountryCode() {
      if (!this.$store.getters.isAllCountry) {
        return this.$store.getters.curCountry.country_code
      }
      const selectedCountry = this.$store.state.page.countryArr.find(item => item.currency === this.currency)
      return selectedCountry?.code || ''
    },
    beneficiaryAccountTypeFormat() {
      const obj = {
        'BANK': this.$t('map.beneficiary_account_type_0'),
        'PROMPTPAY': this.$t('map.beneficiary_account_type_1')
      }
      return function(value) {
        if (value) {
          return obj[value]
        }
        return value
      }
    },
    beneficiaryTypeFormat() {
      const obj = {
        'NATIONAL_ID': this.$t('map.beneficiary_type_0'),
        'MOBILE_NUMBER': this.$t('map.beneficiary_type_1')
      }
      return function(value) {
        if (value) {
          return obj[value]
        }
        return value
      }
    },
    maxAmount() {
      if (this.merchantInfo.disbursement_payout_limit_amount === 1) {
        return this.$commonFn.mathDivide(this.merchantInfo.contract_amount, 100)
      } else {
        return 5000000
      }
    }
  },
  mounted() {
    this.getBeneficiaryList()
  },
  methods: {
    showModal(row) {
      this.dialogTableVisible = true
      if (this.$store.getters.isAllCountry) {
        if (this.currency) {
          this.fetchOverview({ currency: this.currency })
        }
      } else {
        this.fetchOverview()
      }
      this.$nextTick(() => {
        this.initContent()
        this.getBeneficiaryList(row)
      })
    },
    fetchOverview(params = {}) {
      const fetchOverviewApi = this.$store.getters.isAllCountry
        ? fetchMultiMchOverview
        : fetchOverview
      fetchOverviewApi(params).then(res => {
        if (res.code === 10000) {
          this.total_balance = res.data.total_balance
        }
      })
    },
    onCurrencyChange(currency) {
      this.form.beneficiary_id = null
      this.onChangeBeneficiaryList(null)
      this.beneficiaryList = []
      if (!currency) {
        this.total_balance = null
        return
      }
      this.fetchOverview({ currency })
      this.getBeneficiaryList()
    },
    amountTips() {
      if (this.currentCountryCode !== 'VN' && this.form.amount > this.maxAmount) {
        this.$message.warning('The payment amount cannot exceed the amount limit.')
        return
      }
      return true
    },
    getBeneficiaryList(row) {
      const isAllCountry = this.$store.getters.isAllCountry
      if (isAllCountry && !this.currency) {
        this.beneficiaryList = []
        return
      }
      const fetchBeneficiaryListApi = isAllCountry
        ? fetchMultiMchLargeValueBeneficiaryAllList
        : fetchLargeValueBeneficiaryAllList
      const params = isAllCountry ? { currency: this.currency } : undefined
      fetchBeneficiaryListApi(params).then(res => {
        if (res.code === 10000) {
          let list = res.data || []
          list = list.map(item => {
            return {
              ...item,
              label: `${item.disbursement_short_name} - ${item.disbursement_number}${item.disbursement_channel ? ` - ${item.disbursement_channel}` : ''}`,
              value: item.id
            }
          })
          this.beneficiaryList = list
          if (row?.id) {
            this.id_disabled = true
            this.form.beneficiary_id = row.id
            this.onChangeBeneficiaryList(row.id)
          }
        }
      })
    },
    onChangeBeneficiaryList(value) {
      if (value) {
        const item = this.beneficiaryList.find(item => item.id === value)
        this.merchantInfo = item || {}
        this.form = {
          ...this.form,
          account_name: item.disbursement_name,
          amount_limit: item.contract_amount,
          disbursement_order: item.disbursement_order,
          account_no: item.disbursement_number,
          code: item.disbursement_channel,
          merchant_id: item.merchant_id,
          currency: item.currency
        }
        if (this.currentCountryCode === 'TH') {
          this.form.beneficiary_account_type = item.beneficiary_account_type
          if (this.form.beneficiary_account_type === 'BANK') {
            this.form.code = item.disbursement_channel
          }
          if (this.form.beneficiary_account_type === 'PROMPTPAY') {
            this.form.beneficiary_type = item.beneficiary_type
          }
        }
      } else {
        this.merchantInfo = {}
        this.form = {
          ...this.form,
          account_name: '',
          amount_limit: '',
          disbursement_order: '',
          account_no: '',
          code: '',
          merchant_id: ''
        }
      }
    },
    onClickSubmitBtn() {
      if (!this.amountTips()) {
        return
      }
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$confirm(this.$t('tips.whether_to_submit'), this.$t('components.tips'), {
            confirmButtonText: this.$t('components.submit'),
            cancelButtonText: this.$t('components.cancel'),
            type: 'warning'
          }).then(() => {
            this.submiting = true
            // eslint-disable-next-line prefer-const
            let { amount, ...otherForm } = this.form
            amount = this.$commonFn.mathMultiply(amount, 100)
            const params = { amount, ...otherForm }
            if (this.$store.getters.isAllCountry) {
              params.currency = this.currency
            } else {
              delete params.currency
            }
            if (params.disbursement_number) {
              params.disbursement_number = params.disbursement_number.trim()
            }
            if (params.disbursement_name) {
              params.disbursement_name = params.disbursement_name.trim()
            }

            createLargeDisbursement(params).then(res => {
              if (res.code === 10000) {
                this.$message.success('Submit SuccessFully')
                this.closeModal()
                this.$emit('updateList')
              }
            }).finally(() => {
              setTimeout(() => {
                this.submiting = false
              }, 500)
            })
          })
        }
      })
    },
    onClickCancelBtn() {
      this.closeModal()
      this.$emit('showChooseModal')
    },
    closeModal() {
      this.dialogTableVisible = false
    },
    initContent() {
      this.form = {
        amount: undefined,
        beneficiary_id: null
      }
      this.merchantInfo = {}
      this.id_disabled = false
      this.$nextTick(function() {
        this.$refs['form'].clearValidate()
      })
    }
  }
}
</script>
<style>
.diglog-card .el-form-item__label{
  line-height: 36px;
}
.diglog-card .el-form-item {
  margin-bottom: 10px;
}
.diglog-card .el-dialog {
  border-radius: 12px;
}
.diglog-card .el-dialog__title {
  padding-left: 24px;
  color: #3855F1;
}
.diglog-card .section-title {
  margin-top: 24px;
}
</style>
<style scoped lang="scss">
.font_size_title {
  font-size: 18px;
  color: #000000;
}
.account-details-row {
  display: flex;
  gap: 24px;
}
.account-details-row .el-form-item {
  flex: 1;
}
.currency-form-content {
  display: flex;
  align-items: center;
}
.currency-label {
  flex: none;
  margin-right: 12px;
}
.currency-select {
  flex: 1;
}
.btn-container{
  margin-top: 32px;
  display: flex;
  .btn-download,.btn-retry{
    flex: 1;
  }
  .btn-retry{
    margin-left: 24px;
  }
}
.total{
  display: inline-flex;
  justify-content: space-between;
  margin-top: 18px;
  min-width: 300px;

  .line{
    display: inline-block;
    content:'';
    height: 52px;
    width: 1px;
    background: #D3D7DF;
  }
  &-title{
    font-size: 14px;
    line-height: 17px;
    color: #606266;
  }
  &-num{
    margin-top: 12px;
    font-size: 22px;
    font-family: Source Han Sans SC;
    font-weight: 600;  font-family: 'Inter-SemiBold';
    line-height: 1.2;
    color: #3855F1;
  }
}
.item{
  display: flex;
  margin-top: 16px;
  .item-left{
    display: inline-block;
    width: 250px;
  }
}

.content-blue{
  font-weight: 500;  font-family: 'Inter-Medium';
  font-size: 14px;
  line-height: 17px;
  color: #1D3A71;
}
.content-gray{
  flex: 1;
  font-weight: 500;  font-family: 'Inter-Medium';
  font-size: 14px;
  line-height: 15px;
  color: #4B5567;
}

.from-input {
  width: 450px;
}
.payout-second-title {
  font-size: 18px;
  color: #000000;
}
.mb-12{
  margin-bottom: 12px;
}
.mt-12{
  margin-top: 14px
}
.cancel-btn {
  width: 213px;
  height: 44px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 4px;
  color: #FFFFFF;
  background-color: #98a1b4;
}
.confirm-btn {
  width: 213px;
  height: 44px;
  margin-left: 24px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 4px;
}
.cp-btn {
  width: 450px;
  margin-top: 30px;
  display: flex;
  justify-content: space-between;
}
.mt-8 {
  margin-top: 8px;
}
</style>
